document.addEventListener('DOMContentLoaded', function() {
    const viewToggle = document.querySelector('.view-toggle');
    const gridContainer = document.querySelector('.product-grid-container'); // Make sure this matches your container class
    const desktopContainer = document.querySelector('.sort-desktop')
    const mobileContainer = document.querySelector('.sort-mobile')

    if (!viewToggle || !gridContainer) {
        return; // Exit if any element is not found
    }

    if (mobileContainer) {
        const listViewBtn2 = mobileContainer.querySelector('#listBtn2');
        const gridViewBtn2 = mobileContainer.querySelector('#gridBtn2');
        gridViewBtn2.addEventListener('click', function() {
            let productGrid = document.querySelector('.product-grid');
            gridContainer.classList.remove('list-view');
            productGrid.classList.remove('list-view');

            gridViewBtn2.classList.add('active');
            listViewBtn2.classList.remove('active');
            // localStorage.setItem('productView', 'grid'); // Optional: Save view preference
        });

        listViewBtn2.addEventListener('click', function() {
            const productGrid = document.querySelector('.product-grid');
            gridContainer.classList.add('list-view');
            productGrid.classList.add('list-view');
            listViewBtn2.classList.add('active');
            gridViewBtn2.classList.remove('active');

            // localStorage.setItem('productView', 'list'); // Optional: Save view preference
        });
    } else {
        const gridViewBtn = desktopContainer.querySelector('.grid-view-btn');
        const listViewBtn = desktopContainer.querySelector('.list-view-btn');

        gridViewBtn.addEventListener('click', function() {
            let productGrid = document.querySelector('.product-grid');

            gridContainer.classList.remove('list-view');
            productGrid.classList.remove('list-view');
            gridViewBtn.classList.add('active');
            listViewBtn.classList.remove('active');

            // localStorage.setItem('productView', 'grid'); // Optional: Save view preference
        });

        listViewBtn.addEventListener('click', function() {
            const productGrid = document.querySelector('.product-grid');
            
            gridContainer.classList.add('list-view');
            productGrid.classList.add('list-view');
            listViewBtn.classList.add('active');
            gridViewBtn.classList.remove('active');
        });
    }

    // // Optional: Load saved view preference
    // const savedView = localStorage.getItem('productView');
    // if (savedView === 'list') {
    //     const productGrid = document.querySelector('.product-grid');
    //     gridContainer.classList.add('list-view');
    //     productGrid.classList.add('list-view');
    //     listViewBtn.classList.add('active');
    //     gridViewBtn.classList.remove('active');
    // }
});